import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { homeFaqs } from "@/mocks/siteData";

export default function FaqPreview() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-content mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
        <div className="lg:col-span-4">
          <Reveal>
            <SectionHeading
              eyebrow="常见问题"
              title="投稿前，你最想确认的几件事"
              desc="关于匿名、素材与后续处理，我们把被问得最多的问题整理在这里。"
            />
            <Link
              to="/faq"
              className="mt-7 inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部常见问题
              <i className="ri-arrow-right-line"></i>
            </Link>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Reveal delay={100}>
            <FaqAccordion items={homeFaqs} defaultOpenId="hf1" />
          </Reveal>
        </div>
      </div>
    </section>
  );
}